import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'gwc-frontend-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
